import { createContext } from 'react';
import type { CookieConsent } from './types';

export interface ConsentContextValue {
  consent: CookieConsent | null;
  hasConsented: boolean;
  setConsentAndApply: (consent: Partial<CookieConsent>) => void;
  openPreferences: () => void;
  openBanner: () => void;
  preferencesOpen: boolean;
  setPreferencesOpen: (open: boolean) => void;
  bannerOpen: boolean;
  setBannerOpen: (open: boolean) => void;
}

export const ConsentContext = createContext<ConsentContextValue | null>(null);
